const renewCertificate = {
  default: {
    title: 'Renovar el certificado del documento',
    description: 'Selecciona un documento firmado por Clicksign en .PDF.',
  },
  finished: {
    title: '¡Certificado renovado!',
    description: 'Descarga el documento con el certificado renovado.',
    button: 'Descargar documento',
  },
  with_tsa: {
    title: 'El documento tiene un sello de tiempo activo',
    description: 'No es necesario volver a firmar',
  },
};

export default renewCertificate;
